export var PLAYROOM_ACHIEVEMENTS_BY_TYPE = {
  COMPLETE_COURSE: 'COMPLETE_COURSE',
  COMPLETE_PROJECT: 'COMPLETE_PROJECT',
  COMPLETE_QUIZ: 'COMPLETE_QUIZ',
  LEARNING_PATH: 'LEARNING_PATH'
};